import { query } from 'services/query';
import { GET_FOOTFALL_STATISTIC } from 'CONSTANTS/endpoints';

export function getFootfallStatistic(id) {
  return query
    .getRequest({
      url: () => GET_FOOTFALL_STATISTIC(id),
    })
    .then((data) => data);
}
